import axios from "@/axios";
import Axios from "axios";

export default {
  // 获取收币地址
  getBindCodeList(params) {
    return axios.get("uc/user/bindcode/list", params);
  },

  // 新增收币地址
  addBindCode(params) {
    return axios.post("uc/user/bindcode/add", params);
  },

  // 更新收币地址
  updateBindCode(params) {
    return axios.post("uc/user/bindcode/update", params);
  },

  // 删除收币地址
  delBindCode(params) {
    return axios.post("uc/user/bindcode/del", params);
  },

  // 人脸识别
  getInitFaceVerify(data) {
    return Axios({
      url: "/apis/faceVerify/getInitFaceVerify",
      method: "post",
      data
    });
  },
  getAliyunDescribeFaceVerify(params) {
    return Axios({
      url: "/apis/faceVerify/getAliyunDescribeFaceVerify",
      method: "get",
      params
    });
  },
  // 获取腾讯id
  getTencentId(params) {
    return axios.post("validateAppId", params);
  },

  //发送验证码
  getCodeSecure(params) {
    return axios.post("uc/user/bindcode/sendCodeForBindCode", params);
  }
};



// WEBPACK FOOTER //
// ./src/api/digital.js